import { UserInfoDoesNotExistError } from "@seneca/user-service-client";

import { getClient } from "services";

export default async function isUserSignedUp() {
  try {
    const _ = await getClient("userService").fetchMyInfo();
    return true;
  } catch (error) {
    if (error instanceof UserInfoDoesNotExistError) {
      return false;
    }
  }
}
